import { z } from "zod";

/**
 * Loaded `financialDocumentLinks` relation at response boundaries.
 * Optionally typed on TypeORM entities, so the input side accepts
 * `undefined`, but validation rejects it: a query that stops loading
 * the relation fails loudly instead of silently returning no ids.
 */
export const financialDocumentLinksResponseSchema = z
    .array(z.object({ financialDocumentId: z.number() }))
    .optional()
    .refine((links) => links !== undefined, {
        message: "financialDocumentLinks relation is not loaded",
    })
    .transform((links) => links ?? []);

export function toFinancialDocumentIds(
    links: z.infer<typeof financialDocumentLinksResponseSchema>,
): number[] {
    return links.map((link) => link.financialDocumentId);
}
